import { render, staticRenderFns } from "./ManagementPurchasesView.vue?vue&type=template&id=2a782a29&scoped=true"
import script from "./ManagementPurchasesView.vue?vue&type=script&lang=js"
export * from "./ManagementPurchasesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a782a29",
  null
  
)

export default component.exports